import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  Card,
  Container,
  Row,
  Col,
  Table,
  Form,
  Button,
  Modal
} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle, faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { useSelector, useDispatch } from "react-redux";
import Select from "react-select";
import {
  postPersonnel,
  postPersonnelByPerson,
  updatePersonnelReport,
  postPersonnelExcel,
  postPersonnelPDF,
  resetPersonnelReport,
  updateLeaveTaken,
  resetLeaveTaken,
  updateReason,
  resetReason,
  addReasonLate,
} from "./PersonnelSlice";
import { triggerBase64Download } from "common-base64-downloader-react";
import SideMenu from "../../UI/SIdeMenu";
import Navibar from "../../UI/Navibar";
import Footer from "../../UI/Footer";
import axios from "axios";
// import moment from "moment";
import './Personnel.css';

function PersonnelComponent() {
  const dispatch = useDispatch();
  const [inputValue, setInputValue] = useState("");
  const [table, setTable] = useState([]);

  const { personnels, personnelReport, leaveTaken, reason } = useSelector(
    (state) => state.personnelSlice
  );
  const { persons, fromdate, todate } = personnelReport;
  const { date, id, reason_late } = reason;

  const [showAdd, setShowAdd] = useState(false);
  const [showView, setShowView] = useState(false);

  console.log(personnels);

  useEffect(() => {
    const now = new Date();
    const year = now.getFullYear();
    // const month = now.getMonth() + 1;
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const entity = { ...personnelReport, fromdate: `${year}-${month}-01` };
    console.log(entity);
    dispatch(updatePersonnelReport(entity));

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        handleCloseAdd();
        handleCloseView();
      }
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  useEffect(() => {
    if (inputValue) {
      dispatch(postPersonnel(inputValue));
    }
  }, [inputValue]);

  const dayTypeMapping = {
    "WORKDAY": "W",
    "HOLIDAY": "H",
    "RESTDAY": "R"
  };

  const fullNameMapping = {
    "W": "WORKDAY",
    "H": "HOLIDAY",
    "R": "RESTDAY"
  };

  const weekday = [
    "SUN",
    "MON",
    "TUE",
    "WED",
    "THU",
    "FRI",
    "SAT",
  ];
  // const d =new Date("2023-03-22");
  // let day = weekday[new Date("2023-03-22").getDay()]
  // console.log(day)

  const handleChangeForm = (e) => {
    const entity = { ...personnelReport, [e.target.name]: e.target.value };
    dispatch(updatePersonnelReport(entity));
    const entity2 = {
      ...leaveTaken,
      from_date: personnelReport.fromdate,
      to_date: personnelReport.todate,
    };
    dispatch(updateLeaveTaken(entity2));
  };

  const handleChangeDropdownPersonnelName = (selectedOption) => {
    console.log(selectedOption);
    const entity = {
      ...personnelReport,
      persons: { id: selectedOption.value },
    };
    dispatch(updatePersonnelReport(entity));
    console.log(entity);
    const entity2 = { ...leaveTaken, sid: selectedOption.value2 };
    console.log(entity2);
    dispatch(updateLeaveTaken(entity2));
  };

  const handleClickSearch = () => {
    const entity = { ...personnelReport };
    dispatch(postPersonnelByPerson(entity)).then((res) => {
      console.log(res);
      console.log(res.payload);
      let personLists = res.payload;
      console.log(personLists);
      const entity2 = {
        ...leaveTaken,
        from_date: personnelReport.fromdate,
        to_date: personnelReport.todate,
      };
      console.log(entity2);
      setTable(personLists);
      // axios
      //   .post(
      //     "http://192.168.5.149/apiv2/public/index.php/staffonleave/employeeVacationBySID",
      //     entity2
      //   )
      //   .then((res) => {
      //     console.log(res.data);
      //     const leave = res.data;

      //     const result = personLists.map((element2) => {
      //       const matchingLeave = leave.find((element1) => {
      //         const newDate = element1.datetime.date.split("T")[0];
      //         return newDate === element2.cdate;
      //       });

      //       let ampm = "";

      //       if (matchingLeave) {
      //         if (
      //           (matchingLeave.leave_application.from_ampm === "AM" &&
      //             matchingLeave.leave_application.to_ampm === "AM") ||
      //           (matchingLeave.leave_application.from_ampm === "PM" &&
      //             matchingLeave.leave_application.to_ampm === "PM")
      //         ) {
      //           ampm = "Half day";
      //         } else if (
      //           matchingLeave.leave_application.from_ampm === "AM" &&
      //           matchingLeave.leave_application.to_ampm === "PM"
      //         ) {
      //           ampm = "1 day";
      //         }
      //       }

      //       return {
      //         ...element2,
      //         leaveTaken: ampm,
      //       };
      //     });
      //     setTable(result);
      //   })
      //   .catch((err) => {
      //     console.log(err);
      //   });
    });
  };

  const handleExportExcel = () => {
    const entity = { ...personnelReport };
    dispatch(postPersonnelExcel(entity)).then((res) => {
      console.log(res);
      console.log(res.payload);
      const base64EXCEL = "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64," + res.payload.excelContent;
      const personName = res.payload.personName;
      triggerBase64Download(
        base64EXCEL,
        `${personName}- Personnel_Report` + "_" + new Date().toISOString().slice(0, 10)
      );
    });
  };

  const handleExportPdf = () => {
    const entity = { ...personnelReport };
    dispatch(postPersonnelPDF(entity)).then((res) => {
      console.log(res);
      const base64PDF = "data:application/pdf;base64," + res.payload.pdfContent;
      const personName = res.payload.personName;
      triggerBase64Download(
        base64PDF,
        `${personName}- Personnel_Report` + "_" + new Date().toISOString().slice(0, 10)
      );
    });
  };  

  const handleBack = () => {
    const entity = { ...personnelReport };
    dispatch(resetPersonnelReport(entity));
    dispatch(resetReason());
    setTable([]);
  };

  const handleCloseAdd = () => {
    dispatch(resetReason());
    setShowAdd(false);
  };

  const handleCloseView = () => {
    dispatch(resetReason());
    setShowView(false);
  };

  const handleBtnReason = (date, id) => {
    const entity = { ...reason, date: date, id: id};
    console.log(entity);
    dispatch(updateReason(entity));
    setShowAdd(true);
  };

  const handleBtnViewReason = (date, id, reason) => {
    const entity = { ...reason, date: date, id: id, reason_late: reason};
    console.log(entity);
    dispatch(updateReason(entity));
    setShowView(true);
  };

  const handleReasonChange = (e) => {
    const entity = { ...reason, reason_late: e.target.value};
    console.log(entity);
    dispatch(updateReason(entity));
  };

  const handleBtnSumbitReason = async (e) => {
    const entity = { ...reason };
    console.log(entity);
    await dispatch(addReasonLate(entity));
    handleClickSearch();
    dispatch(resetReason());
    setShowAdd(false);
  };

  const handleBtnUpdateReason = async (e) => {
    const entity = { ...reason };
    console.log(entity);
    await dispatch(addReasonLate(entity));
    handleClickSearch();
    dispatch(resetReason());
    setShowView(false);
  };

  const compareTime = (time) => {
    if (!time || time === "") {
      return true;
    }
    const [hours, minutes, seconds] = time.split(":").map(Number);
    const inputDate = new Date(0, 0, 0, hours, minutes, seconds);
    const referenceDate = new Date(0, 0, 0, 8, 31, 0);
    return inputDate < referenceDate;
  };

  // Function to check if time_in is late and format it accordingly
  const formatTime = (time) => {
    const lateTime = '08:30:59';
    return time > lateTime ? `**${time}**` : time;
  };

  return (
    <div className="Div">
      <Container fluid>
        <Row>
          <Col xs={12} className="fixed-top">
            <Navibar />
          </Col>
        </Row>
        <Row>
          <Col
            xs={2}
            id="sidebar-wrapper"
            className="sidemenu"
            style={{ marginTop: "50px" }}
          >
            <SideMenu />
          </Col>
          <Col>
            <Card className="content">
              <Form>
                <Container>
                  <Row className="mb-3 mt-3">
                    <Col md={12}>
                      <h4>PERSONNEL REPORT</h4>
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col md={3}>SEARCH EMPLOYEE:</Col>
                    <Col md={9}>
                      <Select
                        inputValue={inputValue}
                        onInputChange={(value) => setInputValue(value)}
                        onChange={handleChangeDropdownPersonnelName}
                        options={personnels}
                        // value={person}
                        styles={{
                          option: (provided) => ({
                            ...provided,
                            fontWeight: 'bold',
                            textTransform: 'uppercase',
                          }),
                          control: (provided) => ({
                            ...provided,
                            fontWeight: 'bold',
                            textTransform: 'uppercase',
                          }),
                        }}
                      />
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col md={3}>
                      <Form.Label>FROM DATE:</Form.Label>
                    </Col>
                    <Col md={3}>
                      <Form.Control
                        type="date"
                        name="fromdate"
                        value={fromdate}
                        onChange={handleChangeForm}
                        placeholder="dd/mm/yy"
                      ></Form.Control>
                    </Col>
                    <Col md={3}>
                      <Form.Label>TO DATE:</Form.Label>
                    </Col>
                    <Col md={3}>
                      <Form.Control
                        type="date"
                        name="todate"
                        value={todate}
                        onChange={handleChangeForm}
                        placeholder="dd/mm/yy"
                      ></Form.Control>
                    </Col>
                  </Row>
                  <Row className="justify-content-md-center mb-3">
                    <Col xs="auto" md={12}>
                      <Form.Group>
                        <Button
                          type="button"
                          bg="dark"
                          variant="dark"
                          onClick={handleClickSearch}
                        >
                          SEARCH
                        </Button>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Card>
                    <Table bordered responsive>
                      <thead>
                        <tr className="tableheader">
                          <th className="text-center">Date</th>
                          <th className="text-center">Weekday</th>
                          <th className="text-center">Day Type</th>
                          <th className="text-center">In</th>
                          <th className="text-center">Out</th>
                          <th className="text-center">Work</th>
                          <th className="text-center">Overtime</th>
                          <th className="text-center">Short</th>
                          <th className="text-center">Leave Taken</th>
                          <th className="text-center">Reason</th>
                        </tr>
                      </thead>
                      {/* <tbody>
                        {table.map(
                          (
                            {
                              id,
                              cdate,
                              report_day_type,
                              time_in,
                              time_out,
                              overtime,
                              short_in,
                              short_out,
                              total_short,
                              total_work,
                              leaveTaken,
                              reason_late,
                              status
                            },
                            i
                          ) => (
                            <tr key={i} style={{ cursor: "pointer" }}>
                              <td>{cdate}</td>
                              <td>{weekday[new Date(cdate).getDay()]}</td>
                              <td title={fullNameMapping[dayTypeMapping[report_day_type]]}>
                                {dayTypeMapping[report_day_type]}
                              </td>
                              <td style={{ color: !compareTime(time_in) ? "red" : "black" }}>
                                {formatTime(time_in)}
                              </td>
                              <td>{time_out}</td>
                              <td>{total_work}</td>
                              <td>{overtime}</td>
                              <td>{total_short}</td>
                              <td>
                                {status == 1 ? "" : status == 2 ? "AM" : status == 3 ? "PM" : status == 4 ? "FULL" : ""}
                              </td>
                              <td>
                                {!time_in || compareTime(time_in) || report_day_type !== "WORKDAY" ? (
                                  "-"
                                ) : ( 
                                  reason_late ? (
                                    // <FontAwesomeIcon 
                                    //   icon={faCheckCircle} 
                                    //   onClick={() => handleBtnViewReason(cdate, id, reason_late)} 
                                    //   color="#28A745" // Green color for faCheck
                                    // />
                                    <td className="ellipsis" onClick={() => handleBtnViewReason(cdate, id, reason_late)}>
                                      {reason_late}
                                    </td>
                                  ) : (
                                    <FontAwesomeIcon 
                                      icon={faQuestionCircle} 
                                      onClick={() => handleBtnReason(cdate, id)} 
                                      color="#DC3545" // Red color for faQuestionCircle
                                    />
                                  )
                                )}
                              </td>
                            </tr>
                          )
                        )}
                      </tbody> */}
                      {Array.isArray(table) && table.length > 0 ? (
                        <tbody>
                          {table.map(
                            (
                              {
                                id,
                                cdate,
                                report_day_type,
                                time_in,
                                time_out,
                                overtime,
                                short_in,
                                short_out,
                                total_short,
                                total_work,
                                leaveTaken,
                                reason_late,
                                status
                              },
                              i
                            ) => (
                              <tr key={i} style={{ cursor: "pointer" }}>
                                <td>{cdate}</td>
                                <td>{weekday[new Date(cdate).getDay()]}</td>
                                <td title={fullNameMapping[dayTypeMapping[report_day_type]]}>
                                  {dayTypeMapping[report_day_type]}
                                </td>
                                <td style={{ color: !compareTime(time_in) ? "red" : "black" }}>
                                  {formatTime(time_in)}
                                </td>
                                <td>{time_out}</td>
                                <td>{total_work}</td>
                                <td>{overtime}</td>
                                <td>{total_short}</td>
                                <td>
                                  {status == 1 ? "" : status == 2 ? "AM" : status == 3 ? "PM" : status == 4 ? "FULL" : ""}
                                </td>
                                <td>
                                  {!time_in || compareTime(time_in) || report_day_type !== "WORKDAY" ? (
                                    "-"
                                  ) : reason_late ? (
                                    <td
                                      className="ellipsis"
                                      onClick={() => handleBtnViewReason(cdate, id, reason_late)}
                                    >
                                      {reason_late}
                                    </td>
                                  ) : (
                                    <FontAwesomeIcon
                                      icon={faQuestionCircle}
                                      onClick={() => handleBtnReason(cdate, id)}
                                      color="#DC3545" // Red color for faQuestionCircle
                                    />
                                  )}
                                </td>
                              </tr>
                            )
                          )}
                        </tbody>
                      ) : (
                        <tbody>
                          <tr>
                            <td colSpan={10} style={{ textAlign: "center" }}>
                              No data available
                            </td>
                          </tr>
                        </tbody>
                      )}
                    </Table>
                  </Card>
                  <Row className="mb-3 mt-3 d-flex justify-content-between align-items-end">
                    <Col md={1}>
                      <Button
                        type="button"
                        bg="dark"
                        variant="dark"
                        onClick={handleBack}
                      >
                        Back
                      </Button>
                    </Col>
                    
                    <Col md={7}></Col>

                    {/* Center Column with auto margins */}
                    <Col md={2} className="d-flex justify-content-end ml-auto">
                      <Button
                        type="button"
                        bg="dark"
                        variant="dark"
                        onClick={() => handleExportPdf()}
                        style={{ width: '100%' }}
                      >
                        Export PDF Report
                      </Button>

                    </Col>

                    {/* Export Excel Button */}
                    <Col md={2} className="d-flex justify-content-end ml-auto">
                      <Button
                        type="button"
                        bg="dark"
                        variant="dark"
                        onClick={() => handleExportExcel()}
                        style={{ width: '100%' }}
                      >
                        Export Excel Report
                      </Button>
                    </Col>

                    <Modal
                      show={showAdd}
                      onHide={handleCloseAdd}
                      backdrop="static"
                      keyboard={false}
                    >
                      <Modal.Header closeButton>
                        <Modal.Title>ADD REASON</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <Form>
                          <Form.Group>
                            <Form.Label>DATE:</Form.Label>
                            <Form.Control
                              type="text"
                              value={date}
                              readOnly
                            />
                          </Form.Group>
                          <br/>
                          <Form.Group>
                            <Form.Label>REASON:</Form.Label>
                            <Form.Control
                              as="textarea"
                              name="reason"
                              value={reason_late}
                              onChange={handleReasonChange}
                            />
                          </Form.Group>
                        </Form>
                      </Modal.Body>
                      <Modal.Footer>
                        <Button onClick={handleBtnSumbitReason}>SUBMIT</Button>
                      </Modal.Footer>
                    </Modal>

                    <Modal
                      show={showView}
                      onHide={handleCloseView}
                      backdrop="static"
                      keyboard={false}
                    >
                      <Modal.Header closeButton>
                        <Modal.Title>REASON</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <Form>
                          <Form.Group>
                            <Form.Label>DATE:</Form.Label>
                            <Form.Control
                              type="text"
                              value={date}
                              readOnly
                            />
                          </Form.Group>
                          <br/>
                          <Form.Group>
                            <Form.Label>REASON:</Form.Label>
                            <Form.Control
                              as="textarea"
                              name="reason"
                              value={reason_late}
                              onChange={handleReasonChange}
                            />
                          </Form.Group>
                        </Form>
                      </Modal.Body>
                      <Modal.Footer>
                        <Button onClick={handleBtnUpdateReason}>UPDATE</Button>
                      </Modal.Footer>
                    </Modal>
                  </Row>
                </Container>
              </Form>
            </Card>
          </Col>
        </Row>
      </Container>
      <Footer />
    </div>
  );
}

export default PersonnelComponent;
